import Layer from "../../Layer";

export default class Admin extends Layer {
    getMaxWidth() {
        return 1000;
    }
}